import { useTranslation } from 'next-i18next/pages';
import React from 'react';

import { buildInquiryHref } from '@/components/apps/ui/inquiryForm/inquiryCtaSource';

import { SolutionCtaSection } from '../../shared/SolutionCtaSection';

/**
 * ### SafetyInquiryCtaSection
 *
 * Places the shared call-to-action section at the end of the Listen AI Safety
 * page, leading to the inquiry form with the Safety interest and lead source
 * already selected, with the resource library as the secondary action. It
 * carries the same pair as the Industrial page so the two ends read alike;
 * the procurement listing is not repeated here because the innovative-product
 * section already closes on that link.
 *
 * @returns The rendered call-to-action section element
 * @see {@link SolutionCtaSection} The shared section this configures
 */
export default function SafetyInquiryCtaSection() {
  const { t } = useTranslation('common');

  return (
    <SolutionCtaSection
      tone="dark"
      analyticsSectionId="safety_inquiry"
      title={t('Listen AI Safety 도입 문의')}
      description={t('현장 조건에 맞는 구성과 도입 절차를 상담해 보세요')}
      actions={[
        {
          href: buildInquiryHref({
            interest: 'safety-consult',
            source: 'safety-cta',
          }),
          label: t('문의하기'),
          className:
            'bg-apps-coreGrayWhite text-apps-coreGrayBlack hover:bg-apps-brandGray900 hover:text-apps-coreGrayBlack',
          analyticsContentId: 'safety_inquiry',
          analyticsContentType: 'cta',
        },
        {
          href: '/about/resources',
          label: t('관련 자료 보기'),
          variant: 'line',
          analyticsContentId: 'safety_resources',
          analyticsContentType: 'cta',
        },
      ]}
    />
  );
}
